<div data-cy="welcome-page">
    <img class="logo" src="/assets/ORCAN-logo.svg">

    <p class="title" data-cy="welcome-page-title">WELCOME TO ORCAN!</p>

    <p class="main" data-cy="welcome-page-text">The first step to start using ORCAN is to request
        your user role through the correspondent support email below:</p>
    <p class="main" data-cy="welcome-page-text">PNW2 Partners (Special Orders, Claims and Part Number Changes) orcan-support&#64;bmw.de</p>
    <p class="main" data-cy="welcome-page-text">ASCC FinCAB (Financial Settlements Acceptance and Bundles)
        orcan-fincab-support&#64;bmw.de</p>
    <p class="footer" data-cy="welcome-page-footer">See you soon!</p>
</div>
